import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import {
  LanguageService
} from '../../services/language.service';

import {
  BannerService,
  BANNER_SLOTS
} from '../../services/banner.service';

@Component({
  selector: 'app-admin-banners',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './admin-banners.html'
})
export class AdminBanners
implements OnInit {

  banners: any[] = [];
  file: File | null = null;

  // কোন জায়গার ব্যানার + (ঐচ্ছিক) ক্লিক করলে কোথায় যাবে
  slots = BANNER_SLOTS;

  selectedSlot = 'HERO';

  linkUrl = '';

  api =
    'https://superbangladesh-api-1.onrender.com/api/banners';

  constructor(
    private http: HttpClient,
    private bannerService: BannerService,
    public languageService: LanguageService
  ) {}

  slotLabel(key: string | null | undefined): string {

    const s =
      this.slots.find(x => x.key === (key || 'HERO'));

    if (!s) {
      return key || '';
    }

    return this.languageService.language() === 'bn'
      ? s.labelBn
      : s.labelEn;
  }

  bannersFor(key: string): any[] {

    return this.banners.filter(
      b => (b.slot || 'HERO') === key
    );
  }

  t(key: string): string {
    return this.languageService.translate(key);
  }

  ngOnInit() {
    this.load();
  }

  load() {

    this.http.get<any[]>(this.api)
      .subscribe(res => {

        this.banners = res;
      });
  }

  select(event: any) {

    this.file =
      event.target.files[0];
  }

  save() {

    if (!this.file) return;

    const fd = new FormData();

    fd.append(
      'file',
      this.file
    );

    fd.append(
      'slot',
      this.selectedSlot
    );

    if (this.linkUrl.trim()) {

      fd.append(
        'linkUrl',
        this.linkUrl.trim()
      );
    }

    this.http.post(
      this.api,
      fd
    ).subscribe(() => {

      alert(this.t('bannerAdded'));

      this.bannerService.clear();

      this.file = null;
      this.linkUrl = '';

      this.load();
    });
  }

  delete(id: number) {

    if (!confirm(this.t('confirmDeleteQuestion'))) return;

    this.http.delete(
      `${this.api}/${id}`
    ).subscribe(() => {

      this.bannerService.clear();

      this.load();
    });
  }
}